import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isAlreadyUnderMinutes } from '../../../utils/utils';
import classes from './Timer.module.scss';

function computeTimeLeft(targetDate) {
  const diffMs = targetDate.getTime() - Date.now();
  if (diffMs <= 0)
    return { timePassed: true };
  const seconds = Math.floor((diffMs / 1000) % 60);
  const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
  const hours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return { timePassed: false, seconds, minutes, hours, days };
}

const Timer = ({ targetDate, timeReached, onTimeReached }) => {

  const { texts } = useSelector((state) => state.translate);
  const intervalRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState(() => computeTimeLeft(new Date(targetDate)));

  useEffect(() => {
    const t = new Date(targetDate);
    setTimeLeft(computeTimeLeft(t));
    if (!t)
      return;
    const id = setInterval(() => {
      const left = computeTimeLeft(t);
      setTimeLeft(left);
      if (timeReached != null && onTimeReached) {
        if (isAlreadyUnderMinutes(t, timeReached))
          onTimeReached();
      }
      if (left.timePassed)
        clearInterval(id);
    }, 200);
    intervalRef.current = id;
    return () => { clearInterval(id); intervalRef.current = null; };
  }, [targetDate, timeReached, onTimeReached]);

  const pad2 = (n) => String(n).padStart(2, '0');
  const { timePassed, days, hours, minutes, seconds } = timeLeft;

  const units = [
    { key: 'days', value: days, label: texts?.days },
    { key: 'hours', value: hours, label: texts?.hours },
    { key: 'minutes', value: minutes, label: texts?.minutes },
    { key: 'seconds', value: seconds, label: texts?.seconds },
  ];

  let firstVisibleIndex = units.findIndex((unit) => unit.value > 0);
  if (firstVisibleIndex === -1)
    firstVisibleIndex = 2;
  else
    firstVisibleIndex = Math.min(firstVisibleIndex, 2);
  const visibleUnits = units.slice(firstVisibleIndex);

  return (
    <>
      {!timePassed &&
        <div className={classes.TimerWrapper}>
          <div className={classes.group}>
            {visibleUnits.map((unit, index) => (
              <div key={unit.key} className={classes.wrapperBoxAndLabel}>
                <div className={classes.wrapperBox}>
                  {pad2(unit.value).split('').map((digit, i) => <span key={i} className={classes.box}>{digit}</span>)}
                  {index < visibleUnits.length - 1 && <span className={classes.separator}> : </span>}
                </div>
                <span className={classes.label}>{unit.label}</span>
              </div>
            ))}
          </div>
        </div>
      }
    </>
  );
};

export default Timer;